import axios from 'axios';

/** POST /auth/anonymous answers 409 when the refresh cookie already belongs to a signed-in user. */
export const isAuthSessionAlreadyExistsError = (error: unknown): boolean =>
  axios.isAxiosError(error) &&
  error.response?.status === 409 &&
  (error.response.data as { errorCode?: string } | undefined)?.errorCode ===
    'AUTH_SESSION_ALREADY_EXISTS';
